/* eslint-disable react/prop-types */
import React, {useEffect, useState, useRef} from "react";
import {useParams, useHistory} from "react-router";
import {Row, Col, Button, InputGroup, Modal, Form} from "react-bootstrap";
import API from "../Utility";

export default function LibrarySelector({ children, location, ...props }) {
  let { project, groupId } = useParams();
  const [libraries, setLibraries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function getLibraries(query) {
    setIsLoading(true);
    const data = await API.get({
      url: query.url,
      params: query.params,
    });
    setLibraries(data);
    setIsLoading(false);
  }

  useEffect(() => {
    async function initializeData() {
      await getLibraries({
        url: `/admin/${project}/libraries`
      });
    }

    initializeData();
  }, []);

  return (
    <Form.Group>
      <Form.Control as="select" onChange={props.change}>
        <option defaultValue={0} key={0} value={0}>Please select</option>
        {libraries ? libraries.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          return 0;
        }).map(function(item, index) {
          return <option key={++index} value={item._id}>{item.name}</option>;
        })
          : <span>No Linked Libraries</span>}
      </Form.Control>
    </Form.Group>
  );
}
